import { Component, OnInit, Input } from '@angular/core';
import { LocalService } from '../../../service/local.service';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss']
})
export class ProgressBarComponent implements OnInit {
  @Input() value: any = '0'; @Input() isAnimation: boolean = true;
  @Input() reduceWidth: number = 0; id = 'prba_'; idVal = 'prbaval_';
  valueNum: number = 0;
  constructor(private localService: LocalService) { }

  ngOnInit(): void {
    let id = this.localService.getRandomString(5);
    this.id = this.id + id;
    this.idVal = this.idVal + id;
    this.valueNum = parseFloat(this.value);

    setTimeout(() => {
      let element = document.getElementById(this.idVal) as HTMLDivElement;
      if (element) {
        element.style.backgroundPosition = 'left bottom';
      }
    }, 100);
  }

  ngOnChanges(): void {
    this.valueNum = parseFloat(this.value);
  }

}
